// Optional add-on products (custom.add_ons / custom.add_on_variants metafields).
// Ticked add-ons are added by ProductForm (product-form.js) as extra line items.
if (!customElements.get("product-addons")) {
  customElements.define(
    "product-addons",
    class ProductAddons extends HTMLElement {
      connectedCallback() {
        this.form = this.closest("form") || document.getElementById(this.getAttribute("form-id"));
        this.onChange = this.update.bind(this);
        this.addEventListener("change", this.onChange);

        // A variant change re-renders the Add to cart label, so re-apply ours afterwards.
        if (typeof subscribe === "function") {
          this.unsubscribeVariantChange = subscribe(PUB_SUB_EVENTS.productVariantChange, () =>
            requestAnimationFrame(this.onChange),
          );
        }

        this.update();
      }

      disconnectedCallback() {
        this.removeEventListener("change", this.onChange);
        this.unsubscribeVariantChange?.();
      }

      update() {
        // Paid dropdown choices elsewhere in the form (e.g. snippets/product-muzzbar-options.liquid) count too.
        const hasSelected = (this.form || this).querySelector("[data-addon-variant-id]:checked") !== null;
        this.form?.classList.toggle("has-product-addons", hasSelected);
        this.toggleDependentOptions();

        const note = this.querySelector("[data-addon-checkout-note]");
        if (note) {
          note.hidden = !hasSelected;
        }

        const button = this.form?.querySelector('[name="add"]');
        const label = button?.querySelector("span");
        if (!label) {
          return;
        }

        if (hasSelected && !button.disabled) {
          if (!label.dataset.addonsOriginalLabel) {
            label.dataset.addonsOriginalLabel = label.textContent.trim();
          }
          label.textContent = "Add selected items to cart";
        } else if (label.dataset.addonsOriginalLabel) {
          label.textContent = label.dataset.addonsOriginalLabel;
          delete label.dataset.addonsOriginalLabel;
        }
      }

      // Product options tied to an add-on (snippets/product-options.liquid, show_with_addon) only
      // appear - and are only required and submitted - while one of that add-on's switches is ticked.
      toggleDependentOptions() {
        const scope = this.closest(".shopify-section") || document;
        const tickedProducts = new Set(
          Array.from(this.querySelectorAll("[data-addon-product-id]:checked"), (input) => input.dataset.addonProductId),
        );

        scope.querySelectorAll("[data-show-with-addon]").forEach((field) => {
          const show = tickedProducts.has(field.dataset.showWithAddon);
          field.hidden = !show;
          if (field.matches("fieldset")) {
            field.disabled = !show;
            if (!show) {
              field.removeAttribute("aria-invalid");
            }
          }
          field.querySelectorAll("select, input").forEach((control) => {
            control.disabled = !show;
            if (!show) {
              control.removeAttribute("aria-invalid");
            }
          });
        });
      }
    },
  );
}
